export type StyleMixins = {
  adHeight: string
  adWidth: string
}

//Give extra hight on actual return
export const styleMixins: Record<string, StyleMixins> = {
  // NTP 300x250 AD (room for slug)
  304_300: {
    adHeight: '304px',
    adWidth: '300px',
  },
  304_612: {
    adHeight: '304px',
    adWidth: '612px',
  },
  600_300: {
    adHeight: '610px',
    adWidth: '300px',
  },
  auto: {
    adHeight: 'auto',
    adWidth: 'auto',
  },
  728_90: {
    adHeight: '300px',
    adWidth: 'auto',
  },
  300_250: {
    adHeight: '310px',
    adWidth: '250px',
  },
  300_50: {
    adHeight: '100px',
    adWidth: '300px',
  },
  970_90: {
    adHeight: '300px',
    adWidth: '100%',
  },
}
